import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";

import Card from "react-bootstrap/Card";

import { useEsus } from "@/hooks/useEsus";
import { getQuarterDates } from "@/utils/quarters";

import { IndicatorsEmultiFilters } from "./IndicatorEmultiFilters";
import { IndicatorEmultiM1 } from "./IndicatorEmultiM1";
import { IndicatorEmultiM2 } from "./IndicatorEmultiM2";

export function IndicatorsEmulti() {
	const { indicator } = useParams();
	const { healthTeams } = useEsus();
	const [selectedIne, setSelectedIne] = useState<string>();
	const [selectedIndicator, setSelectedIndicator] = useState<number>(
		indicator ? Number(indicator) : 1
	);
	const quarter = Math.ceil((dayjs().month() + 1) / 4);
	const now = dayjs();
	const currentYear = now.year();
	const currentMonth = now.month();
	const [selectedQuarter, setSelectedQuarter] = useState<string>(`Q${quarter}/${currentYear}`);
	const [selectedMonth, setSelectedMonth] = useState<string>(
		String(currentMonth + 1).padStart(2, "0")
	);
	const [isPendingToUpdate, setIsPendingToUpdate] = useState(true);
	const selectedYear = dayjs(getQuarterDates(selectedQuarter).startDate).year();
	const selectedMonthNumber = Number(selectedMonth);

	const indicatorProps = {
		selectedQuarter,
		selectedYear,
		selectedMonth: selectedMonthNumber,
		selectedIne,
		isPendingToUpdate,
		setIsPendingToUpdate,
	};
	function getSelectedIndicator() {
		switch (selectedIndicator) {
			case 1:
				return <IndicatorEmultiM1 {...indicatorProps} />;
			case 2:
				return <IndicatorEmultiM2 {...indicatorProps} />;
			default:
				return <></>;
		}
	}

	useEffect(() => {
		setIsPendingToUpdate(true);
	}, [selectedIndicator]);

	return (
		<>
			<Card className="m-3 p-2">
				<Card.Body>
					<IndicatorsEmultiFilters
						selectedIndicator={selectedIndicator}
						setSelectedIndicator={setSelectedIndicator}
						selectedQuarter={selectedQuarter}
						setSelectedQuarter={setSelectedQuarter}
						selectedMonth={selectedMonth}
						setSelectedMonth={setSelectedMonth}
						selectedIne={selectedIne}
						setSelectedIne={setSelectedIne}
						healthTeams={healthTeams}
						handleFilter={() => setIsPendingToUpdate(true)}
					/>
				</Card.Body>
			</Card>
			{getSelectedIndicator()}
		</>
	);
}
